import { render, staticRenderFns } from "./GroupStudentMove.vue?vue&type=template&id=819dd0be&scoped=true"
import script from "./GroupStudentMove.vue?vue&type=script&lang=ts"
export * from "./GroupStudentMove.vue?vue&type=script&lang=ts"
import style0 from "./GroupStudentMove.vue?vue&type=style&index=0&id=819dd0be&prod&scoped=true&lang=css"
import style1 from "./GroupStudentMove.vue?vue&type=style&index=1&id=819dd0be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "819dd0be",
  null
  
)

export default component.exports